import React from 'react'
import LayoutDefault from '../../layouts/Default'
import ScreenLogin from './screens/ScreenLogin'
import { withTheme } from 'styled-components'

const Login = ({ ...props }) => {
  const meta = {
    title: 'Login | stol.it',
    author: 'stol.it',
    copyright: 'stol.it',
    adsTargeting: {
      STOL7_seite: 'Login',
    },
  }

  return (
    <LayoutDefault meta={meta} superBannerBackground={props.theme.color.multimedia.backgroundSecondary} {...props}>
      <ScreenLogin />
    </LayoutDefault>
  )
}

export default withTheme(Login)
